<template>
	<div class="container">
		<slot></slot>
	</div>
</template>
<script setup lang="ts"></script>

<style lang="scss" scoped>
.container {
	@media screen and (max-width: 1280px) {
		padding: 0rem 2rem;
	}
}
</style>
